import { useToast } from "@chakra-ui/react";
import React from "react";

const GaraazHocToast = (WrappedComponent: any) => {
  return (props: any) => {
    const toast = useToast();
    const notification = ({
      status,
      title = "",
      description,
      duration = 10000,
    }: any) => {
      return toast({
        title: title,
        description: description,
        status: status,
        duration: duration,
        isClosable: true,
        position: "top",
      });
    };

    return <WrappedComponent {...props} notification={notification} />;
  };
};

export default GaraazHocToast;
